import {
  // issueLog fetch type:
  ISSUE_LOG_FETCH_PROCESSING,
  ISSUE_LOG_FETCH_SUCCESS,
  ISSUE_LOG_FETCH_FAILED,
  ISSUE_LOG_FETCH_CLEAR,

  // issueLog update type:
  ISSUE_LOG_UPDATE_SUCCESS,
  ISSUE_LOG_UPDATE_FAILED,
  // ISSUE_LOG_UPDATE_CLEAR,
} from '../constants';

// initialStateIssueLog
const initialStateIssueLog = {
  result: null,
  isLoading: false,
  isError: false,
};

/**
 * issueLogReducer()
 * @param {object} state, issueLog state
 * @param {object} payloads
 * @param {string} payloads.type,
 * @param {any} payloads.payload,
 * @returns new state
 */
export default (state = initialStateIssueLog, { type, payload }) => {
  switch (type) {
    /**
     * CASE: ISSUE_LOG_FETCH_*
     */
    case ISSUE_LOG_FETCH_PROCESSING:
      return {
        ...state,
        result: initialStateIssueLog.result,
        isLoading: true,
        isError: false,
      };
    case ISSUE_LOG_FETCH_SUCCESS:
      return {
        ...state,
        result: payload,
        isLoading: false,
        isError: false,
      };
    case ISSUE_LOG_FETCH_FAILED:
      return {
        result: initialStateIssueLog.result,
        isLoading: false,
        isError: true,
        message: null,
      };
    case ISSUE_LOG_FETCH_CLEAR:
      return {
        ...state,
        ...initialStateIssueLog,
      };

    /**
     * CASE: ISSUE_LOG_UPDATE_*
     */
    case ISSUE_LOG_UPDATE_SUCCESS:
      return {
        ...state,
        result: payload,
        isLoading: false,
        isError: false,
      };
    case ISSUE_LOG_UPDATE_FAILED:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      return state;
  }
};
